<template>
  <div class="rights-record">
    <TablePagination
      v-if="loading"
      ref="RightsRecord"
      :form-config="tableFormConfig"
      :export-enable="false"
      :columns="columns"
      :add-button-enable="false"
      :url="api"
      :params-formatter="paramsFormatter"
      class="filter-form-custom"
      :headerRenderConfig="current===2?headerRenderConfig:false"
    >
    </TablePagination>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      >
        <p style="color:#888D96">未开票的购买记录可申请开具【增值税普票】或【增值税专票】，发票抬头为当前绑定企业</p>
        <p style="text-align: center;padding-top:20px" >开票请联系专属服务顾问</p>
        <div class="main">
          <div class="foin name">{{serviceInfo.service_name}}</div>
          <div class="foin">
            <div class="cellphone">
              <img :src="cellphone" class="icon" alt="电话">
              <span>{{serviceInfo.service_phone}}</span>
            </div>
            <div class="wechat">
              <img :src="WeChat" class="icon" alt="微信">
              <span>{{serviceInfo.service_wechat_no}}</span>
            </div>
          </div>
        </div>
        <div style="text-align: center" slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="dialogVisible = false">好 的</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import TablePagination from "@/components/TablePagination";
import cellphone from "@/assets/img/cellphone.png";
import WeChat from "@/assets/img/WeChat.png";

import {
  columns,
  tableFormConfig,
  columns1,
  tableFormConfig1,
  columns2,
  tableFormConfig2,
} from "./define.js";
/**
 * 招聘权益记录
 * @author zhouyingchao
 */
export default {
  name: "SysAccount",
  components: {
    TablePagination,
  },
  props: ["current"],
  data() {
    return {
      serviceInfo:{},
      cellphone,
      WeChat,
      headerRenderConfig:{
        create: {
          text: '申请开票',
          click: () => this.handleBtnInfo(),
        },
      },
      dialogVisible:false,
      loading:false,
      columns: [],
      api: "",
      tableFormConfig: [],
      info: null,
    };
  },
  async created() {
    this.$axios.post('/recruitment/config/province_city',{
      type:2
    }).then((res) => { 
      let a=res.data.items.map(item=>({'label':item.province,'value':item.province}));
      a.unshift({
        value: null,
        label: "全部",
      },{
        value: '',
        label: "全国",
      });      
      if(a.length>0){
        if (this.current === 2) {
          this.api = "/recruitment/order_employ/list";
          this.columns = columns;
          this.tableFormConfig = tableFormConfig;
          setTimeout(()=>{
            this.$refs["RightsRecord"].$refs.formCustom.handleExpectQuery()
          },200);
        } else if (this.current === 3) {
          this.api = "/recruitment/company/product_log";
          this.columns = columns1;
          this.tableFormConfig = tableFormConfig1(a);
          setTimeout(()=>{
            this.$refs["RightsRecord"].$refs.formCustom.handleExpectQuery()
          },200);
        } else if (this.current === 4) {
          this.$axios.post("/recruitment/company/employer_list").then(resd=>{
            this.api = "/recruitment/company/product_uselog";
            this.columns = columns2;
            this.tableFormConfig = tableFormConfig2(resd.data.items);
            setTimeout(()=>{
              this.$refs["RightsRecord"].$refs.formCustom.handleExpectQuery()
            },200);
          }).catch(err=>{
            console.log(err)
          });
        }
        this.loading = true;
        this.getServiceInfo()
      }
    });
  },
  async mounted() {
    // this.$refs["RightsRecord"].$refs.formCustom.handleExpectQuery();
  },
  methods: {
    getServiceInfo() {
      this.$axios.post("/recruitment/serviceInfo").then((res) => {
        this.serviceInfo = res.data.info;
      });
    },
    handleBtnInfo(){
      this.dialogVisible=true
    },
    /**
     * 加载角色类表
     */
    async loadRoleData() {
      //  await this.$axios.post("/recruitment/order_employ/list").then((res) => {
      //     this.info = res.data;
      //   });
    },

    //筛选前钩子
    paramsFormatter(condition, pagination) {
      let start_time,
        end_time,
        order_type,
        service_state,
        order_no,
        product_type,
        use_user_id,
        province = undefined;
      if (condition.date) {
        start_time = condition.date[0];
        end_time = condition.date[1];
      }
      if (condition.order_type) {
        order_type = condition.order_type[0];
      }
      if (condition.service_state) {
        service_state = condition.service_state[0];
      }
      if (condition.order_no) {
        order_no = condition.order_no;
      }
      if (condition.product_type) {
        product_type = condition.product_type[0];
      }
      if (condition.use_user_id) {
        use_user_id = condition.use_user_id[0];
      }
      if (condition.province) {
        province = condition.province[0];
      }
      return {
        use_user_id,
        product_type,
        province,
        order_no,
        start_time,
        end_time,
        order_type,
        service_state,
        pageInfo: pagination,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
@import "./index.scss";
</style>
